export const passwordChecksV9 = (password = '') => {
  const characters = Array.from(password);
  const bytes = characters.reduce((total, character) => {
    const point = character.codePointAt(0);
    return (
      total + (point <= 0x7f ? 1 : point <= 0x7ff ? 2 : point <= 0xffff ? 3 : 4)
    );
  }, 0);
  return {
    length: characters.length >= 10 && characters.length <= 30 && bytes <= 72,
    uppercase: /\p{Lu}/u.test(password),
    lowercase: /\p{Ll}/u.test(password),
    symbol: /[\p{P}\p{S}]/u.test(password),
  };
};

export const isValidNewPasswordV9 = (password) =>
  Object.values(passwordChecksV9(password)).every(Boolean);
